function formatDate(date,str='-') {
    var d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join(str);
}

//将一个数组分割成二维数组，可指定二维数组元素个数
function group(array, subGroupLength) {
    let index = 0;
    let newArray = [];
    while(index < array.length) {
      newArray.push(array.slice(index, index += subGroupLength));
    }
    return newArray;
}
//时分秒转秒
function toSecond(time) {
    var hour = time.split(':')[0]||0;
    var min = time.split(':')[1]||0;
    var sec = time.split(':')[2]||0;
    return Number(hour*3600) + Number(min*60) + Number(sec);
}
function compare(params) {
    return function (a,b) {
        var valuea=a[params]
        var valueb=b[params]
        if(valuea<valueb){
            return -1
        }else if(valuea>valueb){
            return 1
        }else{
            return 0
        }
        
    }
}
function timeCompared(time,timeList=[{beginTime:'06:30',endTime:'14:30'},{beginTime:'14:30',endTime:'22:30'},{beginTime:'22:30',endTime:'06:30'}]) {
    let num=0
    for(let i=0;i<timeList.length;i++){
        let item=timeList[i]
        if(i==2){
            if(toSecond(item.beginTime)<=toSecond(time)||toSecond(item.endTime)>toSecond(time)){
                num=i
                break ;
            }
        }else{
            if(toSecond(item.beginTime)<=toSecond(time)&&toSecond(item.endTime)>toSecond(time)) {
                num=i
                break ;
            }
        }
    }
    return num===0?'早班':num===1?'中班':'晚班'
}
export {
    group,
    toSecond,
    timeCompared,
    compare,
    formatDate
}


// WEBPACK FOOTER //
// ./src/tool/index.js